$(document).ready(function(){
  if ($('.js-clipboard-element').length > 0 && $('.js-clipboard-target').length > 0) {
    $('.js-clipboard-element').on('click', function() {
      navigator.clipboard.writeText($('.js-clipboard-target').text());
    });
  }
});
